import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const images = [
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/feb84a2a99fbcd7e8ff78c3e17f09320.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d3137d59be0cffa96f7aa072f468a8a7.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/7bf14301ee7a6b604645c9ec2aebae83.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2cd46f844316d9867f1ef19be25f2833.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/567ae914b096be40c10eb487428e7174.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a2515f1fc094fd8ff5b758d413294b54.jpeg",
];

const realisations = [
  {
    id: 1,
    legende: "Remplacement de moteur Somfy – Strasbourg centre",
    alt: "Remplacement de moteur Somfy volet roulant Strasbourg",
  },
  {
    id: 2,
    legende: "Pose de volet roulant aluminium – Schiltigheim",
    alt: "Pose de volet roulant aluminium Schiltigheim",
  },
  {
    id: 3,
    legende: "Réparation de sangle et cordon – Illkirch",
    alt: "Réparation de sangle et cordon Illkirch",
  },
  {
    id: 4,
    legende: "Motorisation complète – Lingolsheim",
    alt: "Motorisation complète volet roulant Lingolsheim",
  },
  {
    id: 5,
    legende: "Remplacement de tablier PVC – Ostwald",
    alt: "Remplacement de tablier PVC Ostwald",
  },
  {
    id: 6,
    legende: "Dépannage urgence volet bloqué – Strasbourg",
    alt: "Dépannage urgence volet bloqué Strasbourg",
  },
];

export default function Realisations() {
  return (
    <section className="bg-[#F5F2EB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold text-center mb-3">
          Nos réalisations
        </h2>
        <p className="text-[#2F4A63] text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Découvrez nos interventions sur le terrain. Ces photos sont des captures de nos chantiers réels en région strasbourgeoise.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {realisations.map((r, i) => (
            <div
              key={r.id}
              className="bg-white rounded-xl border border-[#E2E8F0] overflow-hidden flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <ImagePlaceholder
                  src={images[i]}
                  alt={r.alt}
                  className="w-full h-full"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <p className="text-[#1B2A4A] text-sm font-semibold leading-relaxed">
                  {r.legende}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}